import { formatClipTitle } from '../titleLines'

export function BalancedClipTitle({ title }: { title: string }) {
  const displayTitle = formatClipTitle(title)
  return <h2 className="clip-heading review-balanced-title" aria-label={displayTitle} title={displayTitle}>{displayTitle}</h2>
}
